import { render } from "./Featurette.vue?vue&type=template&id=e45a57a6&scoped=true"
import script from "./Featurette.vue?vue&type=script&lang=js"
export * from "./Featurette.vue?vue&type=script&lang=js"

import "./Featurette.vue?vue&type=style&index=0&id=e45a57a6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e45a57a6"]])

export default __exports__